import { createFileRoute, redirect } from '@tanstack/react-router'
import { CategorizationRulesPage } from '../pages/CategorizationRulesPage'
import { useAuthStore } from '../stores/auth-store'

export const Route = createFileRoute('/categorization-rules' as any)({
    component: CategorizationRulesPage,
    beforeLoad: () => {
        const { isAuthenticated } = useAuthStore.getState()
        if (!isAuthenticated) {
            throw redirect({
                to: '/login',
            })
        }
    },
})
